import { render, staticRenderFns } from "./ProtocoloConfig.vue?vue&type=template&id=ec2f2d56&"
import script from "./ProtocoloConfig.vue?vue&type=script&lang=js&"
export * from "./ProtocoloConfig.vue?vue&type=script&lang=js&"
import style0 from "./ProtocoloConfig.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports